import { render, staticRenderFns } from "./DataFeedsHealth.vue?vue&type=template&id=9b2fce32&lang=html&"
import script from "./DataFeedsHealth.vue?vue&type=script&lang=js&"
export * from "./DataFeedsHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports